<form class="section-content questions" [formGroup]="questionsFormService.form">
  <div class="questions-container">
    <div class="questions-form">
      <div class="questions-form-row">
        <div>
          <div class="typography typography-h3 questions-form-title">
            Как вас зовут?
          </div>
          <input
            formControlName="personalInfo"
            type="text"
            class="input questions-form-input"
            placeholder="Фамилия, имя и отчество"
          />
        </div>
        <div>
          <div class="typography typography-h3 questions-form-title">
            E-mail
          </div>
          <input
            formControlName="email"
            type="text"
            class="input questions-form-input"
            placeholder="name@email.ru"
          />
        </div>
      </div>

      <div class="typography typography-h3 questions-form-title">
        Ваш вопрос
      </div>
      <textarea
        formControlName="comment"
        type="text"
        class="input textarea_vertical-resize questions-form-input questions-form-textarea"
        placeholder="Ваш вопрос или комментарий"
        maxlength="1000"
      >
      </textarea>
      <div class="submission-container grid justify-content-between mt-40">
        <div class="grid-item">
          <label class="questions-checkbox">
            <span class="checkbox">
              <input
                type="checkbox"
                class="checkbox-input"
                formControlName="accept"
              />
              <div class="checkbox-mark"></div>
            </span>
            <div class="typography">
              Я согласен
              <a
                [href]="
                  (mainHost$ | async) +
                    Agreements.PolicyRegardingProcessingPersonalData | formatLink
                "
                class="typography green-basic"
              >
                с условиями обработки персональных данных
              </a>
            </div>
          </label>
        </div>
        <div class="grid-item">
          <button
            [disabled]="
              questionsFormService.form.invalid || questionsFormService.isPending
            "
            class="button questions-submit"
            (click)="sendFormRequest()"
          >
          Отправить сообщение
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
